import React, { useMemo, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import scss from './MobileSessionHistory.module.scss';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import { getSessionData } from '../../../../session-history-panel/utils/formatSessionDate';
import useSessionHistory from '../../../../session-history-panel/hooks/useSessionHistory';
import SessionHistoryDrawer from '../../../../session-history-panel/components/session-history-drawer/SessionHistoryDrawer';

function MobileSessionHistory() {
  const { t, i18n } = useTranslation('story');
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const sessionId = useSelector((state) => state.story.sessionId);

  const { isAdmin, sessionsData, handleSelectSession, handleChangePage } = useSessionHistory({
    isActive: isDrawerOpen,
    fetchOnMount: isMobile,
  });

  const selectedSessionData = useMemo(() => {
    if (!sessionId) {
      return { email: null, date: null };
    }

    const selectedSession = sessionsData.find((session) => session.id === sessionId);

    if (!selectedSession) {
      return { email: null, date: null };
    }

    return getSessionData(selectedSession, i18n.language);
  }, [sessionId, sessionsData, i18n.language]);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleSelectSessionAndClose = (session) => {
    if (session.id === sessionId) {
      return;
    }

    handleSelectSession(session);
    handleCloseDrawer();
  };

  if (!isMobile || !isAdmin) {
    return null;
  }

  return (
    <>
      <button type='button' className={scss.trigger} onClick={handleOpenDrawer}>
        <span className={scss.iconWrapper}>
          <Icon icon={HistoryOutlinedIcon} className={scss.icon} disableCommonColors currentColor />
        </span>

        <span className={scss.textContent}>
          <span className={scss.title}>{t('sessionHistory')}</span>
          {selectedSessionData.email ? <span className={scss.subtitle}>{selectedSessionData.email}</span> : null}
          {selectedSessionData.date ? <span className={scss.subtitle}>{selectedSessionData.date}</span> : null}
        </span>

        <Icon icon={ICONS.CaretUp} className={scss.chevron} />
      </button>

      <SessionHistoryDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        isAdmin={isAdmin}
        onSelectSession={handleSelectSessionAndClose}
        onChangePage={handleChangePage}
      />
    </>
  );
}

export default MobileSessionHistory;
